import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"
import _imports_0 from '@/assets/img/pdf_icon_version4.png'


const _hoisted_1 = { class: "contract-card-header d-flex flex-column flex-md-row justify-content-between align-items-md-center" }
const _hoisted_2 = { class: "d-flex align-items-center mb-2 mb-md-0" }
const _hoisted_3 = { class: "contract-card-title" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "d-flex flex-column flex-md-row align-items-md-center" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table contract-table mb-0" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "fw-bold text-dark" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-end text-nowrap" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]

import {computed} from 'vue';
import userContractService from '@/api/UserContract';
import {piniaCompanySettingsStore} from '@/store/piniaCompanySettingsStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContractList',
  props: {
    contracts: {},
    isBsgSide: { type: Boolean }
  },
  emits: ["open", "delete"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v15c5972f": (companyBgColor.value),
  "v5401c0b4": (companyColor.value)
}))

const piniaCompanySettingsState = piniaCompanySettingsStore();
const companySettings = computed(() => piniaCompanySettingsState.companySettings);

const companyColor = computed(() => companySettings.value?.colorCode || '#15803d');
const companyBgColor = computed(() => companySettings.value?.colorCode
    ? `${companySettings.value.colorCode}15`
    : '#ecfdf5'
);

// isBsgSide: HR view (signs for BSG), otherwise the external user's own view
const props = __props;
const emit = __emit;

function canSign(document: any): boolean {
  return props.isBsgSide ? !document.signedByBsg : !document.signedByUser;
}

function statusBadge(contract: any) {
  if (contract.signedByUser && contract.signedByBsg) {
    return {label: 'Vollständig unterschrieben', class: 'is-success'};
  }
  if (contract.signedByUser) {
    return {label: 'Wartet auf Unterschrift der BSG', class: 'is-info'};
  }
  if (contract.signedByBsg) {
    return {label: 'Wartet auf Unterschrift des Mitarbeiters', class: 'is-warning'};
  }
  return {label: props.isBsgSide ? 'Nicht unterschrieben' : 'Ihre Unterschrift fehlt', class: 'is-warning'};
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.contracts, (contract) => {
    return (_openBlock(), _createElementBlock("div", {
      key: contract.contractId,
      class: "contract-card mb-4"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "contract-card-icon me-3" }, [
            _createElementVNode("i", { class: "fa-solid fa-file-contract" })
          ], -1)),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(contract.contractTypeLabel), 1),
            _createElementVNode("small", _hoisted_4, "vom " + _toDisplayString(contract.createdAt), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", {
            class: _normalizeClass(["contract-status", statusBadge(contract).class])
          }, _toDisplayString(statusBadge(contract).label), 3),
          (__props.isBsgSide && !(contract.signedByUser && contract.signedByBsg))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-outline-danger fw-bold px-3 d-flex justify-content-center ms-md-3 mt-2 mt-md-0 w-100 w-md-auto",
                onClick: ($event: any) => (emit('delete', contract.contractId))
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("i", { class: "fa-solid fa-trash me-1" }, null, -1),
                _createTextVNode(" Löschen ", -1)
              ]))], 8, _hoisted_6))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _cache[2] || (_cache[2] = _createElementVNode("th", null, "Dokument", -1)),
              _createElementVNode("th", _hoisted_9, _toDisplayString(__props.isBsgSide ? 'Mitarbeiter' : 'Ihre Unterschriften'), 1),
              _cache[3] || (_cache[3] = _createElementVNode("th", { class: "text-center" }, "BSG", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("th", null, null, -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contract.documents, (document) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: document.id
              }, [
                _createElementVNode("td", _hoisted_10, [
                  _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa-regular fa-file-lines text-muted me-2" }, null, -1)),
                  _createTextVNode(_toDisplayString(document.documentTypeLabel), 1)
                ]),
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["signature-pill", document.signedByUser ? 'is-signed' : 'is-pending'])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-solid me-1", document.signedByUser ? 'fa-check' : 'fa-clock'])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(document.signaturesByUser) + " / " + _toDisplayString(document.requiredSignaturesByUser), 1)
                  ], 2)
                ]),
                _createElementVNode("td", _hoisted_12, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["signature-pill", document.signedByBsg ? 'is-signed' : 'is-pending'])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-solid me-1", document.signedByBsg ? 'fa-check' : 'fa-clock'])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(document.signaturesByBsg) + " / " + _toDisplayString(document.requiredSignaturesByBsg), 1)
                  ], 2)
                ]),
                _createElementVNode("td", _hoisted_13, [
                  (document.signedByUser && document.signedByBsg)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-light border fw-bold px-3 me-2 d-inline-flex align-items-center justify-content-center btn-sm contract-open-button",
                        title: "PDF anzeigen",
                        onClick: ($event: any) => (_unref(userContractService).showDocumentPdf(document.id))
                      }, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "PDF",
                          style: {"width":"16px","height":"auto"},
                          class: "me-1"
                        }, null, -1),
                        _createElementVNode("span", { style: {"font-size":"12px"} }, "PDF", -1)
                      ]))], 8, _hoisted_14))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-sm fw-bold px-3 d-inline-flex align-items-center contract-open-button", canSign(document) ? 'btn-primary' : 'btn-outline-primary']),
                    onClick: ($event: any) => (emit('open', document.id))
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-solid me-2", canSign(document) ? 'fa-signature' : 'fa-eye'])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(canSign(document) ? 'Öffnen und unterschreiben' : 'Ansehen'), 1)
                  ], 10, _hoisted_15)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]))
  }), 128))
}
}

})